import { render, staticRenderFns } from "./expert-submit-success.vue?vue&type=template&id=9cab965e&"
import script from "./expert-submit-success.vue?vue&type=script&lang=js&"
export * from "./expert-submit-success.vue?vue&type=script&lang=js&"
import style0 from "./expert-submit-success.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports